import React from 'react';

import FormContext from './FormContext';

const FieldContextFeeder =
  Component =>
  ({ ...props }) =>
    (
      <FormContext.Consumer>
        {form => {
          // Automagically apply stuff from form data based on name
          let label;
          let placeholder;
          let options;
          let info;

          if (form) {
            const field = form.fields?.find(field => field.name === props.name);
            if (field) {
              ({ label, placeholder, info } = field);

              if (field.options)
                options = field.options.map(o => ({
                  value: o.value,
                  label: o.label || o.text, // Some legacy forms use text instead of label
                  text: o.text,
                  tooltip: o.tooltip,
                }));
            }
          }

          // Omit fallback labels so they don't get passed to the DOM
          const {
            fallbackLabel,
            fallbackPlaceholder,
            fallbackOptions,
            fallbackInfo,
            ...rest
          } = props;

          return (
            <Component
              {...rest}
              // Let explicit placeholders and labels override server values
              // But allow fallbacks as well
              label={props.label || label || props.fallbackLabel}
              placeholder={
                props.placeholder || placeholder || props.fallbackPlaceholder
              }
              options={props.options || options || props.fallbackOptions}
              info={props.info || info || props.fallbackInfo}
            />
          );
        }}
      </FormContext.Consumer>
    );

export default FieldContextFeeder;
